module.exports = __webpack_public_path__ + "static/media/en.35455d80.pdf";